import actionTypes from './action-types';
import { setAds } from 'tradera-state/ads/actions';
import { selectPreferredLanguageCode } from 'tradera-state/language/selectors';
import { getTraderaShopProductData } from './api';
import { logger } from 'packages/logger';
import getInitialState from './initial-state';

export const initialize = initData => ({
    type: actionTypes.INITIALIZE,
    payload: getInitialState(initData)
});

export const fetchTraderaShopProductData = urlSlug => async (
    dispatch,
    getState
) => {
    const preferredLanguageCode = selectPreferredLanguageCode(getState);
    dispatch(setIsLoading(true));
    try {
        const { product, item } = await getTraderaShopProductData(
            urlSlug,
            preferredLanguageCode
        );
        dispatch(setItemDetails(item.itemDetails));
        dispatch(setProduct(product));
        dispatch(setAds(item.reduxContainer.ads));
        dispatch(setIsLoading(false));
    } catch (error) {
        const status = error.response && error.response.status;
        if (status === 404) {
            // Handle server side.
            window.location.reload();
        } else {
            logger(error);
        }
    }
};

const setProduct = product => dispatch => {
    dispatch({ type: actionTypes.SET_PRODUCT, payload: product });
};

const setItemDetails = itemDetails => dispatch => {
    dispatch({ type: actionTypes.SET_ITEM_DETAILS, payload: itemDetails });
};

const setIsLoading = isLoading => dispatch => {
    dispatch({ type: actionTypes.SET_IS_LOADING, payload: isLoading });
};
